<script lang="ts">
    import { faTrash } from '@fortawesome/free-solid-svg-icons'
    import Zinput from '../_common/z/zinput.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'
    import ZContainer from '../_common/z/z-container.svelte'
    import ZContainerCol from '../_common/z/z-container-col.svelte'
    import type { Service } from '../../modules/posApi/services/service'

    export let service: Service

    function removeItem() {
        service = null
    }
</script>

{#if service}
    <ZContainer class="mt-2" gapRow="8px" gapCol="8px">
        <Zinput size={3} sizeM={12} label="Nome" type="text" bind:value={service.name} />
        <!-- o sufixo "min" era um addon do input-group; no Zinput ele cabe no próprio rótulo -->
        <Zinput size={2} sizeM={6} label="Duração (min)" type="number" bind:value={service.duration} />
        <Zinput size={2} sizeM={6} label="Valor {window.configs.currency}" type="number" bind:value={service.price} />
        <Zinput size={2} sizeM={12} label="É avaliação" type="toggle" bind:value={service.consulting} />
        <ZContainerCol size={1} sizeM={12}>
            {#if !service.serviceId}
                <Zbutton color="red" icon={faTrash} on:click={removeItem} />
            {/if}
        </ZContainerCol>
    </ZContainer>
{/if}
